import { List } from "antd";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { Checkbox, Flex } from "antd";
import ButtonComponent from "components/button/Button";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import dayjs from "dayjs";

const Article = ({ t, item, onSelected, setIdSelecteds, idSelecteds }) => {
  const history = useHistory();

  return (
    <List.Item className="list-article-item" locale={{ emptyText: "データがありません" }}>
      <Flex gap="large" align="center">
        <Checkbox
          checked={idSelecteds?.includes(item?.id)}
          onChange={(e) => {
            const checked = e.target.checked;
            if (onSelected) {
              onSelected({ item, checked: e.target.checked });
            }

            if (setIdSelecteds && idSelecteds) {
              setIdSelecteds((ids) => {
                let newIds = [...ids];
                if (checked && !newIds.includes(item?.id)) {
                  newIds.push(item?.id);
                } else {
                  newIds = newIds.filter((it) => it !== item?.id);
                }

                return newIds;
              });
            }
          }}
        />
        <img
          src={item?.thumbnail ? item.thumbnail : "/icons/image.png"}
          className="image-thumbnail"
        />
        <div>
          <div className="article-title">{item.subject}</div>
          <div className="article-content">
            {t("articles.lastEditedDate")}:
            {item?.last_modified_date
              ? dayjs(`${item?.last_modified_date} UTC`).format(
                "YYYY/MM/DD HH:mm"
              )
              : ""}
          </div>
        </div>
      </Flex>

      <ButtonComponent
        background="#0687BB"
        className="preview-button"
        text={t("articles.preview")}
        type="button"
        onClick={() => {
          history.push(`/admin/articles/${item.id}/edit`);
        }}
      />
    </List.Item>
  );
};

const Articles = (props) => {
  const {
    data,
    onSelected = () => { },
    idSelecteds = [],
    setIdSelecteds,
  } = props;
  const { t } = useTranslation();

  return (
    <List
      size="small"
      bordered
      className="list-article"
      dataSource={data}
      locale={{ emptyText: "データがありません" }}
      renderItem={(item) => (
        <Article
          t={t}
          item={item}
          onSelected={onSelected}
          idSelecteds={idSelecteds}
          setIdSelecteds={setIdSelecteds}
        />
      )}
    />
  );
};

export default Articles;
